const VALIDATION_PATH_PREFIX = /^(?:body|querystring|params|headers)(?:\/\S*)?\s+/;

export const stripValidationErrorPrefix = (message: string): string =>
  message.replace(VALIDATION_PATH_PREFIX, '').trim();
